/* eslint-disable no-console */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import styled from 'styled-components';
// import { sendLog } from '../../../utils/log'
import PropTypes from 'prop-types';

const StyledContainer = styled.div`
	font-family: 'Circular', 'Helvetica', 'Arial', sans-serif;
	height: 100vh;
	max-height: 100vh;
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	& > * {
		margin-bottom: 20px;
		&:last-child {
			margin-bottom: 0;
		}
	}
`;

const StyledButton = styled.button`
	width: 300px;
	height: 48px;
	font-size: 16px;
	line-height: 24px;
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0;
	padding: 12px 24px;
	border: none;
	border-radius: 5px;
	color: #ffffff;
	font-family: inherit;
	background-color: #eb1d24;
	text-align: center;
	text-decoration: none;
	outline: 0;
	cursor: pointer;
	opacity: 1;
	transition: opacity 0.2s ease;
	&:disabled {
		opacity: 0.8;
		cursor: not-allowed;
	}
	&.disabled {
		opacity: 0.8;
		cursor: not-allowed;
	}
	&:not(:last-child) {
		margin-bottom: 12px;
	}
`;
class ErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, error: null };
	}

	static getDerivedStateFromError(error) {
		console.log(error);
		// Update state so the next render will show the fallback UI.
		return { hasError: true, error };
	}

	componentDidCatch(error) {
		// You can also log the error to an error reporting service
		// logErrorToMyService(error, errorInfo);

		console.log(error);
		// sendLog(error.message, window.location.href)
	}

	render() {
		if (this.state.hasError) {
			// You can render any custom fallback UI
			return (
				<StyledContainer>
					<h1
						style={{
							fontSize: '36px',
							textAlign: 'center',
							marginBottom: '5px',
						}}
					>
						Ooops !
					</h1>
					<h2 style={{ fontSize: '26px', textAlign: 'center' }}>
						Une erreur est survenue
					</h2>
					<b>Erreur : {this.state.error.message}</b>
					<StyledButton
						onClick={() => {
							window.location.href = '/';
						}}
					>
						Retour
					</StyledButton>
				</StyledContainer>
			);
		}
		return this.props.children;
	}
}

ErrorBoundary.propTypes = {
	children: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node,
	]).isRequired,
};

export default ErrorBoundary;
